import { useLayoutEffect } from 'react';

export const useLockBodyScroll = (): void => {
  useLayoutEffect(() => {
    // Check if body is already locked (e.g. by another modal underneath)
    // If so, we don't need to do anything, and we DEFINITELY shouldn't 
    // capture 'hidden' as the original style to restore later.
    const computedStyle = window.getComputedStyle(document.body).overflow;
    if (computedStyle === 'hidden') {
      return;
    }

    // Get original inline value of style
    const originalStyle = document.body.style.overflow;

    // Prevent scrolling on mount
    document.body.style.overflow = 'hidden';

    // Re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []); // Empty array ensures effect is only run on mount and unmount
};

export default useLockBodyScroll;
